export enum TECHNICAL_INFO_TEST_IDS {
    APP_VERSION_TEXT = 'app_version_text',
    APP_REALVERSION_TEXT = 'app_realversion_text',
    APP_PRODUCTVERSION_TEXT = 'app_productversion_text',
}
